module.exports = __webpack_public_path__ + "static/errolson-44438ead5e3d48169df1494d499ea9b3.jpg";